<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-file-import"></i> {{title | translate}}</h4>
    <div class="text-right">
      <button class="btn btn-outline-success mt-2 mb-1 font-weight-bold"
              type="button" (click)="addRow()">+ {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-alert-add-document></app-alert-add-document>
    <form [formGroup]="documentForm">
      <div class="row">
        <div class="col">
          <table class="table table-sm">
            <thead class="thead-dark">
            <tr>
              <th scope="col" class="width-th-1">#</th>
              <th scope="col" class="width-th-2">{{ "TABLE.HEADER.WORKFLOW" | translate }}</th>
              <th scope="col" class="width-th-6">{{ "TABLE.HEADER.SUBJECT" | translate }}</th>
              <th scope="col" class="width-th-3">{{ "TABLE.HEADER.FILE" | translate }}</th>
              <th scope="col" class="width-th-4">{{ "TABLE.HEADER.PROGRESS" | translate }}</th>
              <th scope="col" class="width-th-5"
                  [hidden]="hideDeleteItemOnlyRecord">{{ "TABLE.HEADER.ACTION" | translate }}
              </th>
            </tr>
            </thead>
            <tbody formArrayName="arrayDocument">
            <tr *ngFor="let group of arrayDocument.controls; let index= index" [formGroupName]="index">
              <td class="font-weight-bold display">{{ index + 1}}</td>
              <td title="{{ 'TABLE.HEADER.WORKFLOW' | translate }}:">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <div class="input-group-text"><i class="fa fa-code-branch" aria-hidden="true"></i></div>
                  </div>
                  <select id="workflowInput"
                          class="form-control w-100"
                          formControlName="workflow">
                    <option *ngFor="let workflow of workflows"
                            [ngValue]="workflow">{{workflow.description | translate}}</option>
                  </select>
                </div>
              </td>
              <td title="{{ 'TABLE.HEADER.SUBJECT' | translate }}:">
                <div class="input-group">
                  <div class="input-group-prepend w-39">
                    <div class="input-group-text"><i class="far fa-keyboard" aria-hidden="true"></i></div>
                  </div>
                  <input type="text" class="form-control w-100"
                         formControlName="subject">
                </div>
              </td>
              <td title="{{ 'TABLE.HEADER.FILE' | translate }}:">
                <div class="col padding-select-file content-file">
                  <div class="custom-file content-file">
                    <input type="file" class="custom-file-input w-100" accept="application/pdf"
                           id="customFile{{index}}" (change)="changeStatus($event, index)">
                    <div class="custom-file-label text-left">
                      <label for="customFile{{index}}">
                        {{group.get('filename').value ? group.get('filename').value : 'MESSAGE.SELECT' | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="progress form-group mt-2 ">
                  <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
                       [style.width.%]="getProgress(index)"> {{getProgress(index) + '%'}}
                  </div>
                </div>
              </td>
              <td class="text-center" [hidden]="hideDeleteItemOnlyRecord">
                <i class="fa fa-times mt-2" [routerLink]="" (click)="deleteRow(index)"></i>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" [disabled]="documentForm.invalid || loading"
            (click)="save()">
      <i class="fa fa-bookmark"></i>  {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i>  {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
